import type { Dossier } from '@/mocks/dossiers';

export default function ForeshadowSection({ dossier }: { dossier: Dossier }) {
  return (
    <section id="foreshadows" className="scroll-mt-24">
      <header className="flex flex-wrap items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
          <i className="ri-eye-off-line text-lg" />
        </span>
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">被忽略的伏笔</h2>
      </header>
      <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600">
        这些碎片当时看起来都是多余的，事后才被逐一验证。
      </p>

      <ul className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {dossier.foreshadows.map((item, index) => (
          <li key={item.title} className="flex h-full flex-col rounded-lg border border-accent-200 bg-accent-50 p-5">
            <span className="font-heading text-2xl font-bold text-accent-400">
              {String(index + 1).padStart(2, '0')}
            </span>
            <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-foreground-950">{item.title}</h3>
            <p className="mt-2 font-body text-sm leading-relaxed text-foreground-700">{item.desc}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}